<template>
    <div :style="{fontSize:fSize+'px'}">
        <slot></slot>
    </div>
</template>

<script>

    let defaultWidth = 1600,
        defaultFont = 16,
        minWidth = 768,
        minHeight = 400,
        defaultHeight = 800;

    export default {
        name: 'Resize',
        mounted () {
            window.addEventListener('resize',this.onResize.bind(this));
            this.$root.$emit('onResize');
        },
        data () {
            return {
                vW:  window.innerWidth,
                vH:  window.innerHeight
            }
        },
        computed: {
            fSize () {
                if (!this.$root.isMobile) {
                    return 16 * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
                } else {
                    return 16;
                }
            }
        },
        methods: {
            onResize () {
                this.$root.$emit('onResize');
                this.vW = window.innerWidth;
                this.vH = window.innerHeight;
            }
        }

    }
</script>




// WEBPACK FOOTER //
// Resize.vue?292aba0d